export function calculateAge(dob: Date): number {
  const now = new Date()
  let age = now.getFullYear() - dob.getFullYear()
  const monthDiff = now.getMonth() - dob.getMonth()

  if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < dob.getDate())) {
    age--
  }

  return age
}

export function formatFee(fee: number): string {
  return `₹${fee.toLocaleString('en-IN')}`
}

export function formatDate(date: Date): string {
  return date.toISOString().split('T')[0] // YYYY-MM-DD
}
